// Add your custom JS here.

jQuery(function($) {
	var desktopNav = window.matchMedia('(min-width: 1200px)');
	var submenuCount = 0;

	function setSubmenuState($dropdown, isOpen) {
		$dropdown.toggleClass('show', isOpen);
		$dropdown.children('.dropdown-menu').first().toggleClass('show', isOpen);
		$dropdown.children('.dropdown-toggle').first().attr('aria-expanded', isOpen ? 'true' : 'false');
		$dropdown.children('.jo-submenu-toggle').first().attr('aria-expanded', isOpen ? 'true' : 'false');
	}

	function setupClickableParentDropdowns() {
		$('#main-nav .navbar-nav > .dropdown > .dropdown-toggle').each(function() {
			var $toggle = $(this);
			var $dropdown = $toggle.parent('.dropdown');
			var $menu = $dropdown.children('.dropdown-menu').first();
			var $button = $dropdown.children('.jo-submenu-toggle').first();
			var menuId = $menu.attr('id');
			var label = $.trim($toggle.text()) || 'submenu';

			if (!menuId) {
				submenuCount++;
				menuId = 'jo-submenu-' + submenuCount;
				$menu.attr('id', menuId);
			}

			$toggle.removeAttr('data-bs-toggle data-toggle').attr('aria-expanded', 'false');

			if (!$button.length) {
				$button = $('<button class="jo-submenu-toggle" type="button" aria-expanded="false"><span class="jo-submenu-toggle-icon" aria-hidden="true"></span></button>');
				$toggle.after($button);
			}

			$button.attr({
				'aria-controls': menuId,
				'aria-label': 'Toggle ' + label + ' submenu'
			});

			if (desktopNav.matches) {
				setSubmenuState($dropdown, false);
			}
		});
	}

	setupClickableParentDropdowns();

	$(document).on('click', '#main-nav .jo-submenu-toggle', function(e) {
		e.preventDefault();
		e.stopPropagation();

		var $dropdown = $(this).parent('.dropdown');

		setSubmenuState($dropdown, $(this).attr('aria-expanded') !== 'true');
	});

	if (desktopNav.addEventListener) {
		desktopNav.addEventListener('change', setupClickableParentDropdowns);
	} else {
		desktopNav.addListener(setupClickableParentDropdowns);
	}

	$('#navbarNavOffcanvas').on('hidden.bs.offcanvas', function() {
		$('#main-nav .dropdown').each(function() {
			setSubmenuState($(this), false);
		});
	});
});

	
jQuery ( document ).ready ( function($) {

	// This one for linking to another page with a # anchor
	var hash= window.location.hash
	if ( hash == '' || hash == '#' || hash == undefined ) return false;

	    
      var target = $(hash);
    
      var headerHeight = $("nav.navbar").height() + 100; // Get fixed header height
      //headerHeight = 120;
	//alert(headerHeight);

      
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      
      if (target.length) {
        $('html,body').stop().animate({
          scrollTop: target.offset().top - headerHeight //offsets for fixed header
        }, 'linear');
        
      }

} );


jQuery(document).ready(function($) {
	 // this one for smooth scroll with offset anchors within a page
	(function($) {
		
	  $('a[href*=#]:not([href=#])').click(function() 
	  {
		if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') 
			|| location.hostname == this.hostname) 
		{
		
			//console.log('event1');
			$('#navbarNavOffcanvas').removeClass('show').attr('aria-hidden', 'true');
			$('.offcanvas-backdrop').removeClass('show').attr('aria-hidden', 'true');
			$('body').removeClass('offcanvas-backdrop offcanvas-open').css('overflow', '');
			//console.log('event2');
		  
		  var target = $(this.hash),
		  headerHeight = $("nav.navbar").height() + 15; // Get fixed header height
				
		  target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
				  
		  if (target.length) 
		  {
			$('html,body').animate({
			  scrollTop: target.offset().top - headerHeight
			}, 500);			
			return false;
		  }
		  
		
		  
		}
		
		
	  });
	})(jQuery);
	
} );


// Contact Form 7: disable submit + show loading state on click,
// re-enable on validation/spam/mail failures, keep disabled on success.
jQuery(document).ready(function($) {

	function joCf7SetSubmitting($form, isSubmitting) {
		var $btn = $form.find('.wpcf7-submit');
		if (!$btn.length) return;

		if (isSubmitting) {
			if (!$btn.data('jo-original-text')) {
				$btn.data('jo-original-text', $btn.val());
			}
			$btn.prop('disabled', true)
				.addClass('jo-cf7-submitting')
				.val('Sending…');
		} else {
			var orig = $btn.data('jo-original-text');
			$btn.prop('disabled', false)
				.removeClass('jo-cf7-submitting');
			if (orig) {
				$btn.val(orig);
			}
		}
	}

	function joCf7TrackSubmission(e, $form) {
		var nativeEvent = e.originalEvent || e;
		var detail = nativeEvent.detail || {};
		var formId = detail.contactFormId || $form.find('input[name="_wpcf7"]').val() || '';
		var unitTag = detail.unitTag || $form.find('input[name="_wpcf7_unit_tag"]').val() || $form.attr('id') || '';
		var containerPostId = detail.containerPostId || $form.find('input[name="_wpcf7_container_post"]').val() || '';
		var eventName = 'cf7_submission';
		var eventParams = {
			form_id: String(formId),
			form_unit_tag: String(unitTag),
			container_post_id: String(containerPostId),
			page_location: window.location.href,
			page_path: window.location.pathname,
			page_title: document.title
		};

		if (typeof window.gtag === 'function') {
			window.gtag('event', eventName, eventParams);
			return;
		}

		if (window.dataLayer && typeof window.dataLayer.push === 'function') {
			window.dataLayer.push(Object.assign({ event: eventName }, eventParams));
		}
	}

	// CF7 fires this just before the AJAX submit (after client-side validation passes).
	$(document).on('wpcf7beforesubmit', function(e) {
		joCf7SetSubmitting($(e.target), true);
	});

	// Re-enable on any failure case so the user can correct + retry.
	$(document).on('wpcf7invalid wpcf7spam wpcf7mailfailed', function(e) {
		joCf7SetSubmitting($(e.target), false);
	});

	// On success, leave the button disabled (form is cleared by CF7 anyway),
	// but restore the original label.
	$(document).on('wpcf7mailsent', function(e) {
		var $form = $(e.target);
		var $btn = $form.find('.wpcf7-submit');
		var orig = $btn.data('jo-original-text');
		joCf7TrackSubmission(e, $form);
		$btn.removeClass('jo-cf7-submitting');
		if (orig) {
			$btn.val(orig);
		}
	});
});


// Pricing page: currency and billing selector.
jQuery(function() {
	function formatNumber(config, currencyKey, number) {
		var currency = config.currencies[currencyKey] || {};
		var value = Math.round(Number(number) || 0);

		return value.toLocaleString(currency.locale || undefined);
	}

	function formatMoney(config, currencyKey, number) {
		var currency = config.currencies[currencyKey] || {};

		return (currency.symbol || '') + formatNumber(config, currencyKey, number);
	}

	function setPressed(root, selector, dataKey, value) {
		root.querySelectorAll(selector + ' button').forEach(function(button) {
			button.setAttribute('aria-pressed', button.dataset[dataKey] === value ? 'true' : 'false');
		});
	}

	function renderPricing(root, config, state) {
		var billing = config.billing[state.bill];
		var currency = config.currencies[state.ccy];

		if (!billing || !currency) {
			return;
		}

		root.querySelectorAll('[data-plan]').forEach(function(card) {
			var planKey = card.dataset.plan;
			var plan = config.plans[planKey];

			if (!plan || !plan.prices || typeof plan.prices[state.ccy] === 'undefined') {
				return;
			}

			var base = Number(plan.prices[state.ccy]);
			var headline = base * Number(billing.multiplier);
			var symbolEl = card.querySelector('[data-sym]');
			var priceEl = card.querySelector('[data-price]');
			var periodEl = card.querySelector('[data-per]');
			var sublineEl = card.querySelector('[data-sub]');
			var creditQuantityEl = card.querySelector('[data-credit-quantity]');
			var creditPeriodEl = card.querySelector('[data-credit-period]');
			var ctaEl = card.querySelector('[data-pricing-cta]');

			if (symbolEl) {
				symbolEl.textContent = currency.symbol;
			}
			if (priceEl) {
				priceEl.textContent = formatNumber(config, state.ccy, headline);
			}
			if (periodEl) {
				periodEl.textContent = billing.period;
			}
			if (creditQuantityEl && typeof billing.credit_multiplier === 'number') {
				creditQuantityEl.textContent = formatNumber(config, state.ccy, plan.credits * billing.credit_multiplier);
			}
			if (creditPeriodEl && billing.credit_period) {
				creditPeriodEl.textContent = billing.credit_period;
			}
			if (sublineEl) {
				sublineEl.textContent = billing.subline;

				if (billing.savings_prefix && billing.savings_suffix) {
					sublineEl.textContent = billing.subline + ' ';

					var saveEl = document.createElement('span');
					saveEl.className = 'save';
					saveEl.textContent = billing.savings_prefix + formatMoney(config, state.ccy, base) + billing.savings_suffix;
					sublineEl.appendChild(saveEl);
				}
			}
			if (ctaEl && plan.cta_url && plan.cta_message) {
				var message = plan.cta_message
					.replace('{billing}', billing.message_label || '')
					.replace('{currency}', state.ccy)
					.replace('{price}', formatNumber(config, state.ccy, headline))
					.replace('{period}', billing.message_period || '');
				var querySeparator = plan.cta_url.indexOf('?') === -1 ? '?' : '&';

				ctaEl.href = plan.cta_url + querySeparator + 'your-message=' + encodeURIComponent(message);
			}
		});

		var creditNoteEl = root.querySelector('[data-credit-note]');

		if (creditNoteEl && billing.credit_note) {
			creditNoteEl.textContent = billing.credit_note;
		}

		setPressed(root, '.seg.billing', 'bill', state.bill);
		setPressed(root, '.seg.ccy', 'ccy', state.ccy);
	}

	function bindSegment(root, selector, state, config, stateKey, dataKey) {
		var segment = root.querySelector(selector);

		if (!segment) {
			return;
		}

		segment.addEventListener('click', function(event) {
			var button = event.target.closest('button');

			if (!button || !segment.contains(button) || !button.dataset[dataKey]) {
				return;
			}

			state[stateKey] = button.dataset[dataKey];
			renderPricing(root, config, state);
		});
	}

	document.querySelectorAll('[data-kyboa-pricing]').forEach(function(root) {
		var dataEl = root.querySelector('.kyboa-pricing-config');

		if (!dataEl) {
			return;
		}

		var config;

		try {
			config = JSON.parse(dataEl.textContent);
		} catch (error) {
			return;
		}

		var state = {
			bill: config.defaults && config.defaults.billing ? config.defaults.billing : 'monthly',
			ccy: config.defaults && config.defaults.currency ? config.defaults.currency : 'USD'
		};

		bindSegment(root, '.seg.billing', state, config, 'bill', 'bill');
		bindSegment(root, '.seg.ccy', state, config, 'ccy', 'ccy');
		renderPricing(root, config, state);
	});
});
